import {
    useMutation,
} from '@tanstack/react-query'

import requests from 'app/requests/CQuote.requests'
import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import {
    ContractCurrency,
    ProductType,
    DeliveryServiceType, CollectionServiceType,
} from 'app/enums/label.enums'

export type CQuoteRequestData = {
    lane: { id: number },
    pricingAccount: { id: number },
    expPalletsYear: number,
    productType: ProductType,
    originAirport: { id: number },
    destinationAirport: { id: number },
    deliveryServiceType: DeliveryServiceType,
    collectionServiceType: CollectionServiceType,
    handoverPoint: { id: number },
    collectionDropoffPoint: { id: number },
    currency: ContractCurrency,
    rentalDays: number,
    logisticsDays: number,
    customerQuotation: { id: number },
    skyCellContact: { id: number },
    quotedFor: { id: number },
    generatePdf: boolean
    locationName?: string,
}

export default ({
    onSuccess: onSuccessExternal,
}: {
    onSuccess: ({
        id: number,
    }) => void
}) => {
    const token = useJWTToken()

    const {
        onSuccess,
        onError,
    } = useHandleStatusRequest({
        title: 'New C-Quote was created',
        id: 'CQuoteCreated',
        onSuccess: onSuccessExternal,
    })

    return useMutation({
        mutationFn: (cQuote: CQuoteRequestData) => {
            return simpleApi({
                ...requests.create(cQuote),
                token,
            })
        },
        onError,
        onSuccess,
    })
}
